export const TOOLTIP_SECTION_LABEL_MAX_WIDTH = 150;
export const TOOLTIP_SECTION_ROW_LINK_TEST_ID = "tooltip-section-row-link";
